// extracted by mini-css-extract-plugin
export default {"previewNotification":"XONUbO"};